import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Lg_Title } from '../../../../../utils/EN/Modals/PostModals';

const ModalPostLg = () => {
  return (
    <>
      <ModalVideo
        id="lg-post"
        dataText={Lg_Title}
        videoSrc="https://player.vimeo.com/video/243976843?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_LG"
      />
    </>
  );
};

export default ModalPostLg;
